import React, { useEffect, useState } from 'react';
import { Autocomplete, Box, TextField } from '@mui/material';
import Routes from '../../routes';

// Page-level System Manager / Region-Division filter (AB#17146 AC 1): one filter
// over the whole page — the Assets by Applicable Regulation chart and all three
// consolidation tabs read it together.
const PageFilters = ({ value, onChange }) => {
    const [options, setOptions] = useState({ systemManagers: [], regions: [] });

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const response = await fetch(Routes.ComplianceCenter.PageFilters(), {
                    method: 'GET',
                    headers: { Accept: 'application/json' },
                });
                if (!response.ok) return;
                const data = await response.json();
                if (!cancelled) {
                    setOptions({
                        systemManagers: data.systemManagers ?? [],
                        regions: data.regions ?? [],
                    });
                }
            } catch (error) {
                console.error('Failed to load Compliance Center page filters', error);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    const selectSx = {
        width: '220px',
        '& .MuiInputBase-root': { fontSize: '13px' },
    };

    return (
        <Box sx={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', mb: 1 }}>
            <Autocomplete
                size="small"
                options={options.systemManagers}
                value={value.systemManager}
                onChange={(e, newValue) => onChange({ ...value, systemManager: newValue })}
                renderInput={(params) => <TextField {...params} label="System Manager" />}
                sx={selectSx}
            />
            <Autocomplete
                size="small"
                options={options.regions}
                value={value.regionDivision}
                onChange={(e, newValue) => onChange({ ...value, regionDivision: newValue })}
                renderInput={(params) => <TextField {...params} label="Region / Division" />}
                sx={selectSx}
            />
        </Box>
    );
};

export default PageFilters;
